export class ReportParameterInfo {
    allowBlank: boolean;
    multiValue: boolean;
    name: string;
    prompt: string;
    promptUser: boolean;
    selectedValues: string[];
    type: ParameterTypeEnum;
    validValues: ValidValue[];
}

export class ValidValue {
    public label: string;
    public value: string;
}

export class ExecutionInfo {
    allowQueryExecution: boolean;
    autoRefreshInterval: number;
    credentialsRequired: boolean;
    dataSourcePrompts: DataSourcePrompt[];
    executionDateTime: Date;
    executionID: string;
    expirationDateTime: Date;
    hasDocumentMap: boolean;
    hasSnapshot: boolean;
    historyID: string;
    needsProcessing: boolean;
    numPages: number;
    parameters: ReportParameter[];
    parametersRequired: boolean;
    reportPageSettings: PageSettings;
    reportPath: string;
}

export class PageSettings {
    margins: ReportMargins;
    paperSize: ReportPaperSize;
}

export class DataSourcePrompt {
    dataSourceID: string;
    name: string;
    prompt: string;
}

export class ReportMargins {
    bottom: number;
    left: number;
    right: number;
    top: number;
}
export class ReportPaperSize {
    height: number;
    width: number;
}

export class Warning {
    public Code: string;
    public Severity: string;
    public ObjectName: string;
    public ObjectType: string;
    public Message: string;
}

export class ReportExportResult {
    public currentPage: number;
    public streamIDs: string[];
    public executionInfo: ExecutionInfo;
    public reportData: string;
    public format: string;
    public formatType: Format;
    public mimeType: string;
    public warnings: Warning[];
    public totalPages: number;
    public name: string;
    public parameters: ReportParameterInfo[];
    public reportUrl: string;
    public listOfTypesToDisplay: Format[];
    public isException: boolean;
    public errorCode: number;
    public message: string;
}

export class ReportParameter {
    public Name: string;
    public Type: ParameterTypeEnum;
    public TypeSpecified: boolean;
    public Nullable: boolean;
    public NullableSpecified: boolean;
    public AllowBlank: boolean;
    public AllowBlankSpecified: boolean;
    public MultiValue: boolean;
    public MultiValueSpecified: boolean;
    public QueryParameter: boolean;
    public QueryParameterSpecified: boolean;
    public Prompt: string;
    public PromptUser: boolean;
    public PromptUserSpecified: boolean;
    public Dependencies: string[];
    public ValidValuesQueryBased: boolean;
    public ValidValuesQueryBasedSpecified: boolean;
    public ValidValues: ValidValue[];
    public DefaultValuesQueryBased: boolean;
    public DefaultValuesQueryBasedSpecified: boolean;
    public DefaultValues: string[];
    public State: ParameterStateEnum;
    public StateSpecified: boolean;
    public ErrorMessage: string;
}

export enum ParameterTypeEnum {
    Boolean,
    DateTime,
    Integer,
    Float,
    String,
}

export enum ParameterStateEnum {
    HasValidValue,
    MissingValidValue,
    HasOutstandingDependencies,
    DynamicValuesUnavailable,
}

export enum Format {
    Undefined,
    Rgdi,
    Xml,
    Csv,
    Atom,
    Pdf,
    Html40,
    Mhtml,
    Excel,
    ExcelOpenXml,
    Rpl,
    Word,
    WordOpenXml,
    Tiff,
    Jpeg,
    Gif,
    Png,
    Bmp
}

export enum ReportType {
    Measures_raport = 1,
    Predefined_report_based_on_stored_procedure = 2,
    File_raport = 3,
    PLIP_A = 4,
    PLIP_B = 5,
    PLIP_C = 6,
    Job_raport = 7,
    Server_reporting_services = 8
}

export class SsrsReportRequestModel {
    currentPage: number;
    id: number;
    format : Format;
    parameters: { [key: string]: string[] };
    subreportId: string;
}


